import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
export function FitnessReviews() {
  // Select specific fitness/adult/family friendly reviews
  const reviews = STORM_REVIEWS.filter(r => ['David Bushman', 'Alecia Williams', 'Mike Seibert'].includes(r.name));
  return <section className="py-24 bg-off-white" data-id="element-1465">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1466">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1467">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1468">
            Hear From Our Students
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1469">
            See how Storm Taekwondo has helped adults and families in Southeast
            Michigan achieve their fitness and personal goals.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-1470">
          {reviews.map((review, idx) => <ReviewCard key={idx} quote={review.quote} name={review.name} label={review.label} data-id="element-1471" />)}
        </div>
      </div>
    </section>;
}